<template>
  <div>
    <!--<common-header />-->
    <div class="info-div">
      <div class="header">
        <h3>{{ $t("sampleApply.orderDetail.orderDetailTitle") }}</h3>
      </div>
      <div class="body">
        <!--基本信息-->
        <div class="title">
          {{ $t("sampleApply.orderDetail.baseInfo") }}
        </div>
        <div class="module">
          <div class="module-item">
            <span>{{ $t("sampleApply.order.orderNo") }}：{{ orderDetail.orderNo }}</span>
            <span>
              {{ $t("sampleApply.order.orderStatus") }}：{{ getOrderStatus(orderDetail.orderStatus) }}
              <!--<i v-if="orderDetail.orderStatus == 3" class="el-icon-warning-outline">查看取消原因</i>-->
              <el-popover
                v-if="orderDetail.orderStatus == 3"
                placement="bottom"
                trigger="hover"
                width="150"
                :content="orderDetail.cancelReason"
              >
                <el-button
                  slot="reference"
                  class="el-icon-warning-outline"
                  type="text"
                >{{ $t("sampleApply.orderDetail.showCancelReason") }}</el-button>
              </el-popover>
            </span>
          </div>
          <div class="module-item">
            <span>{{ $t("sampleApply.order.expressNo") }}：{{
              orderDetail.expressNo != null && orderDetail.expressNo.trim() != ''
                ? orderDetail.expressNo : $t("sampleApply.orderDetail.noExpressInfo")
            }}
            </span>
            <span>{{ $t("sampleApply.order.orderTime") }}：{{ orderDetail.createTime }}</span>
          </div>
          <div class="module-item">
            <span style="width: 100%">{{ $t("sampleApply.preOrder.remarks") }}：{{ formatString(orderDetail.remarks) }}</span>
          </div>
        </div>
        <!--收货信息-->
        <div class="receive-message">
          <div class="title">
            {{ $t("sampleApply.order.receiveInfo") }}
          </div>
          <i
            class="el-icon-document-copy"
            @click="copyReceiveMessage"
          />
        </div>
        <div class="module">
          <div class="module-item">
            <span>{{ $t("sampleApply.accountInfo.receiver") }}：{{ orderDetail.receivePersonName }}</span>
            <span>{{ $t("sampleApply.accountInfo.phone") }}：{{ orderDetail.phone }}</span>
          </div>
          <div class="module-item">
            <span class="receive-address-span">{{ $t("sampleApply.accountInfo.receiveAddress") }}：
              {{ orderDetail.province }}
              {{ orderDetail.city }}
              {{ orderDetail.country }}
              {{ orderDetail.detailAddress }}
            </span>
          </div>
        </div>
        <!--项目信息-->
        <div class="title">
          {{ $t("sampleApply.preOrder.projectInfo") }}
        </div>
        <div class="module">
          <div class="module-item">
            <span style="width: 80%">{{ $t("sampleApply.preOrder.directCustomer") }}{{ formatString(projectInformation.directCustomer) }}</span>
          </div>
          <div class="module-item">
            <span>{{ $t("sampleApply.preOrder.mainFactory") }}{{ formatString(projectInformation.mainFactory) }}</span>
            <span>{{ $t("sampleApply.preOrder.projectName") }}{{ formatString(projectInformation.projectName) }}</span>
          </div>
          <div class="module-item">
            <span>{{ $t("sampleApply.preOrder.functionalPart") }}{{ formatString(projectInformation.functionalPart) }}</span>
            <span>{{ $t("sampleApply.preOrder.annualConsumption") }}{{ formatString(projectInformation.annualConsumption) }}</span>
          </div>
          <div class="module-item">
            <span v-if="projectInformation.productionTime != null && projectInformation.productionTime.trim().length > 0">
              {{ $t("sampleApply.preOrder.productionTime") }}{{ projectInformation.productionTime.substring(0, 10) }}
            </span>
            <span v-else>
              {{ $t("sampleApply.preOrder.productionTime") }}-
            </span>
            <span v-if="projectInformation.closingTime != null && projectInformation.closingTime.trim().length > 0">
              {{ $t("sampleApply.preOrder.closingTime") }}{{ projectInformation.closingTime.substring(0, 10) }}
            </span>
            <span v-else>
              {{ $t("sampleApply.preOrder.closingTime") }}-
            </span>
          </div>
        </div>
        <div class="module" style="padding: 0">
          <el-table
            :data="orderDetail.sampleGoodsList"
            style="width: 100%; background: rgba(0,0,0,0)"
          >
            <el-table-column
              :label="$t('sampleApply.order.item')"
              width="70"
              type="index"
            />
            <el-table-column
              prop="partNo"
              :label="$t('sampleApply.orderDetail.jidcPartNo')"
            />
            <el-table-column
              :label="$t('sampleApply.preOrder.category')"
            >
              <template slot-scope="scope">
                <div>{{ $translate(scope.row.category, scope.row.category) }}</div>
              </template>
            </el-table-column>>
            <!--<el-table-column-->
            <!--  prop="createTime"-->
            <!--  label="参数信息">-->
            <!--</el-table-column>-->
            <el-table-column
              prop="goodsNumber"
              :label="$t('sampleApply.preOrder.quantity')"
            />
          </el-table>
        </div>
      </div>
      <div class="footer">
        <!--<common-footer />-->
      </div>
    </div>
  </div>
</template>

<script>
  import CommonHeader from "@/components/CommonHeader";
  import CommonFooter from "@/components/CommonFooter";
  
  export default {
    name: "SampleOrderDetail",
    components: {
      // CommonHeader,
      // CommonFooter
    },
    data() {
      return {
        addressBean: {},
        addressList: [], //省份
        cityList: [], //市
        countyList: [], //区
        formLabelWidth: '80px',
        // 收货信息拷贝按钮拷贝内容
        copyContext: "",
        // 样品订单详情
        orderDetail: {},
        // 操作记录集合
        operationList: [],
        // 订单中的样品
        sampleGoodsList: [],
        projectInformation: {
          id: "",
          orderId: "",
          directCustomer: "",
          projectName: "",
          mainFactory: "",
          functionalPart: "",
          annualConsumption: "",
          productionTime: "",
          closingTime: "",
        },
        orderNo: this.$route.query.sampleOrderNo,
      }
    },
    created() {
      this.getOrderDetailByOrderNo();
    },
    methods: {
      // 将订单状态标识转换为对应的字符串
      getOrderStatus(orderStatus) {
        if (orderStatus == 0) {
          return this.$t("sampleApply.order.orderStatusList.waitDeal");
        } else if (orderStatus == 1) {
          return this.$t("sampleApply.order.orderStatusList.dealing");
        } else if (orderStatus == 2) {
          return this.$t("sampleApply.order.orderStatusList.hasSend");
        } else if (orderStatus == 3) {
          return this.$t("sampleApply.order.orderStatusList.canceled");
        } else {
          return "-";
        }
      },
      // 拷贝功能实现
      copyReceiveMessage() {
        // 创建输入框元素
        let oInput = document.createElement('input');
        // 将想要复制的值
        oInput.value = this.copyContext;
        // 页面底部追加输入框
        document.body.appendChild(oInput);
        // 选中输入框
        oInput.select();
        // 执行浏览器复制命令
        document.execCommand('Copy');
        // 弹出复制成功信息
        this.$message.success(this.$t("common.copySuccess"));
        // 复制后移除输入框
        oInput.remove();
      },
      // 获取样品订单详情
      getOrderDetailByOrderNo() {
        let url = `/order/sample-order/getOrderDetailByOrderNo`;
        let param = {
          orderNo: this.orderNo,
          userId: localStorage.getItem("userId"),
        }
        this.$doPost(url, param).then((res) => {
          if (res.code == 200) {
            this.orderDetail = res.data;
            this.projectInformation = this.orderDetail.projectInformation;
            this.copyContext = `${this.orderDetail.receivePersonName} ${this.orderDetail.phone}  ${this.orderDetail.province}${this.orderDetail.city}${this.orderDetail.country}${this.orderDetail.detailAddress}`;
          }
        }).catch((err) => {
          console.log(err);
        })
      },
      // 格式化输出，为null或者全为空格的字符串显示-
      formatString(str) {
        if (str == null || str.trim().length == 0) {
          return "-";
        }
        return str;
      },
    }
  }
</script>

<style scoped lang="less">
  .info-div {
    /*width: 80%;*/
    margin: 0 auto;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 60%;
    margin: 0 auto;
  }
  
  .body {
    width: 60%;
    margin: 10px auto 0 auto;
    
    .el-icon-warning-outline {
      color: #67c23a;
      margin-left: 10px;
      cursor: pointer;
      padding: 0;
    }
  
    /deep/ .el-button.el-icon-warning-outline {
      border: none;
    }
  
    /deep/ .el-table__cell {
      text-align: center;
    }
    
    .title {
      font-weight: bold;
      font-size: 18px;
    }
    
    .receive-message {
      display: flex;
      i {
        margin-left: 7px;
        margin-top: 5px;
        cursor: pointer;
      }
      i:hover {
        color: #5daf34;
      }
      
      span {
        margin-left: 7px;
        color: #5daf34;
        cursor: pointer;
      }
      span:hover {
        font-weight: bold;
      }
    }
    
    .module {
      color: rgb(70, 70, 70);
      line-height: 20px;
      font-size: 16px;
      border-radius: 10px;
      margin-top: 10px;
      margin-bottom: 10px;
      background: white;
      padding: 15px;
      box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
      /deep/ .el-table {
        border-radius: 10px;
      }
      .module-item {
        display: flex;
        justify-content: flex-start;
        margin: 10px 15px;
        
        span {
          width: 50%;
        }
        
        .receive-address-span {
          width: 90%;
        }
      }
    }
    
    .operation-module {
      border: none;
    }
  }

  .vselect {
    display: flex;
  }
  .vselect > div:not(:last-child) {
    margin-right: 15px;
  }
  
  .footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  
  /deep/ .el-dialog__footer {
    padding-top: 0;
  }
  .dialog-footer.receive-message {
    text-align: center;
  }
  /deep/ .el-dialog__body {
    padding-bottom: 0;
  }
</style>